import KumovegaError from "./KumovegaError";

export default class RequestUnauthorized extends KumovegaError {}
